import EventNextBannerWidget from './components/EventNextBanner/widget.svelte';

var div = document.getElementById('cobraticket-event-next-banner');

let embed;
if (div) {
	var script = document.currentScript;
	var attributes: any = {};
	if (script) {
		script.parentNode?.appendChild(script);
		for (var i = 0; i < script.attributes.length; i++) {
			var attr = script.attributes[i];
			attributes[attr.name] = attr.value;
		}
	}
	console.log('attributes', attributes);
	embed = new EventNextBannerWidget({
		target: div,
		props: {
			publicKey: attributes['public-key'],
			primaryColor: attributes['primary-color'],
			buttonText: attributes['button-text'],
			secondaryColor: attributes['secondary-color'],
			darkMode: attributes['dark-mode'],
			borderRadius: attributes['border-radius']
		}
	});
}
export default embed;
